<template>
    <!-- 登录提示  -->
    <div class="popup-login-tips" v-if="popShow" :class="[lang]">
        <p v-html="$t('popup.loginTips')"></p>
        <div class="popup-tips-arrow"></div>
    </div>
</template>

<script>
export default {
    name: 'popup-login-tips',
    computed: {
        popShow() {
            return this.$store.state.toolbarType === 'unauth';
        },
        commText() {
            return this.$store.state.commText;
        },
        lang() {
            return this.$store.state.lang;
        }
    },
    methods: {}
};
</script>

<style lang="less" scoped>
.popup-login-tips {
    width: 441px;
    background: url(~@/assets/img/pop_mid_repeat.png) center/100% 100% repeat-y;
    max-height: 780px;
    min-height: 200px;
    // margin: auto;
    position: absolute;
    left: 50%;
    margin-left: -220px;
    bottom: 98px;
    z-index: 1;
    // padding-top: 26px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    p {
        text-align: center;
        font-size: 24px;
        line-height: 2;
        color: #9c9273;
    }

    // &.ru {
    //     padding-top: 28px;
    //     p {
    //         font-size: 24px;
    //     }
    // }

    .popup-tips-arrow {
        width: 42px;
        height: 48px;
        position: absolute;
        bottom: -72px;
        left: 50%;
        margin-left: -21px;
        background: url(~@/assets/img/tips_arr.png) center/100% 100% no-repeat;
        animation: 0.6s ease-in-out infinite alternate-reverse tipsAni;

        @keyframes tipsAni {
            from {
                transform: translateY(0);
            }
            to {
                transform: translateY(5px);
            }
        }
    }

    &::before {
        content: '';
        width: 441px;
        height: 26px;
        background: url(~@/assets/img/pop_mid_top.png) center/100% 100%
            no-repeat;
        position: absolute;
        top: -24px;
        left: 0;
    }
    &::after {
        content: '';
        width: 441px;
        height: 19px;
        background: url(~@/assets/img/pop_mid_bottom.png) center/100% 100%
            no-repeat;
        position: absolute;
        bottom: -17px;
        left: 0;
    }
}
</style>
